<template>
  <img v-if="!lazy"
       class="ym-image-component"
       :src="source"
       :alt="alt"
       @click="handleClick"
  >
  <img v-else
       v-lazy="source"
       :alt="alt"
  >
</template>

<script>
  export default {
    name: 'YmImg',
    props: {
      src: {
        type: String,
        require: true,
        default: require('@/assets/img/default/loading.gif'), // eslint-disable-line global-require
      },
      alt: {
        type: String,
        default: '图片',
      },
      lazy: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      source() {
        const { src } = this;
        if (src && src !== '') return src;
        return require('@/assets/img/default/loading.gif'); // eslint-disable-line global-require
      },
    },
    methods: {
      handleClick() {
        this.$emit('click');
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

</style>
